module.exports = __webpack_public_path__ + "media/images/icons/calculator-efb6befb096609fce65eba3bf321c081.svg";